import { prettyPrintEnumValue } from "encamp-shared/src/utils/prettyPrintEnumValue";
import { UserStatus } from "generated-graphql/graphql";

type confirmMessageProps = {
  roleEditPermissionChange: string;
  roleName: string;
  userName: string;
  isPartner: boolean;
  action: "edit" | "add";
};

export function getConfirmMessage({
  roleEditPermissionChange,
  roleName,
  userName,
  isPartner,
  action,
}: confirmMessageProps) {
  let confirmMessage = `You have selected the "${roleName}" role for ${userName}, `;

  // Determine the access change message based on the role change.
  const accessChangeMessage =
    roleEditPermissionChange === "increase"
      ? "which will grant access to every facility in your organization"
      : roleEditPermissionChange === "decrease"
        ? "which will restrict access to only the facilities that you associate them to"
        : "which will grant access to your organization";

  confirmMessage += accessChangeMessage;

  confirmMessage = isPartner
    ? (confirmMessage += " and all partner organizations.")
    : (confirmMessage += ".");

  return confirmMessage;
}

export const prettyPrintUserStatus = (userStatus: UserStatus) => {
  switch (userStatus) {
    case UserStatus.Pending:
      return "Invite Sent";
    case UserStatus.Disabled:
      return "Deactivated";
    default:
      return prettyPrintEnumValue(userStatus);
  }
};
